// src/lib/omie.js
// Integração Omie — credenciais via .env.local, polling horário comercial

import { supabase } from './supabase.js'

const OMIE_CREDS={
  "CRO DIST":    {app_key:import.meta.env.VITE_OMIE_KEY_CRO_DIST,    app_secret:import.meta.env.VITE_OMIE_SECRET_CRO_DIST},
  "CRO EQUIP":   {app_key:import.meta.env.VITE_OMIE_KEY_CRO_EQUIP,   app_secret:import.meta.env.VITE_OMIE_SECRET_CRO_EQUIP},
  "CRO TI":      {app_key:import.meta.env.VITE_OMIE_KEY_CRO_TI,      app_secret:import.meta.env.VITE_OMIE_SECRET_CRO_TI},
  "ESFERA":      {app_key:import.meta.env.VITE_OMIE_KEY_ESFERA,       app_secret:import.meta.env.VITE_OMIE_SECRET_ESFERA},
  "CFM DIST":    {app_key:import.meta.env.VITE_OMIE_KEY_CFM_DIST,     app_secret:import.meta.env.VITE_OMIE_SECRET_CFM_DIST},
  "M.A. DIST":   {app_key:import.meta.env.VITE_OMIE_KEY_MA_DIST,      app_secret:import.meta.env.VITE_OMIE_SECRET_MA_DIST},
  "CRUZEIRO":    {app_key:import.meta.env.VITE_OMIE_KEY_CRUZEIRO,     app_secret:import.meta.env.VITE_OMIE_SECRET_CRUZEIRO},
  "CRO TECINFO": {app_key:import.meta.env.VITE_OMIE_KEY_CRO_TECINFO,  app_secret:import.meta.env.VITE_OMIE_SECRET_CRO_TECINFO},
  "ESPAÇO":      {app_key:import.meta.env.VITE_OMIE_KEY_ESPACO,       app_secret:import.meta.env.VITE_OMIE_SECRET_ESPACO},
  "C.A.S.":      {app_key:import.meta.env.VITE_OMIE_KEY_CAS,          app_secret:import.meta.env.VITE_OMIE_SECRET_CAS},
};

const LS_LAST_CHECK="estoqueos_omie_last_check";
const POLL_INTERVAL_MS=15*60*1000; // 15 minutos
const HORA_INICIO=8;
const HORA_FIM=18;

function dentroDoHorarioComercial(){
  const h=new Date().getHours();
  return h>=HORA_INICIO&&h<HORA_FIM;
}

async function getLastCheck(){
  try{
    const{data}=await supabase.from('config').select('value').eq('key','omie_last_check').single();
    if(data?.value)return data.value;
  }catch(e){}
  return new Date(Date.now()-24*60*60*1000).toISOString();
}

async function setLastCheck(ts){
  try{
    await supabase.from('config').upsert({key:'omie_last_check',value:ts,updated_at:new Date().toISOString()},{onConflict:'key'});
  }catch(e){}
}

// Busca NFs faturadas no Omie para uma empresa desde uma data
const OMIE_PROXY="https://jjndzkkwheixsdeizwsr.supabase.co/functions/v1/omie-proxy";
const SUPABASE_ANON_KEY="eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImpqbmR6a2t3aGVpeHNkZWl6d3NyIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzMxNzM5NTcsImV4cCI6MjA4ODc0OTk1N30.7D6C2GxC_4etlWGE5vXPVEaI5lPO5w1s7Zfsb8es90M";

async function buscarNFsFaturadas(empresa,desde){
  const creds=OMIE_CREDS[empresa];
  if(!creds?.app_key||creds.app_key.startsWith("undefined"))return[];
  const dtInicio=desde.slice(0,10).split("-").reverse().join("/");
  try{
    const resp=await fetch(OMIE_PROXY,{
      method:"POST",
      headers:{
        "Content-Type":"application/json",
        "Authorization":`Bearer ${SUPABASE_ANON_KEY}`,
      },
      body:JSON.stringify({
        endpoint:"produtos/nfconsultar",
        payload:{
          call:"ListarNF",
          app_key:creds.app_key,
          app_secret:creds.app_secret,
          param:[{
            pagina:1,
            registros_por_pagina:50,
            apenas_importado_api:"N",
            filtrar_por_data_de:dtInicio,
            filtrar_por_data_ate:new Date().toLocaleDateString("pt-BR").replace(/\//g,"/"),
          }]
        }
      })
    });
    if(!resp.ok){
      if(resp.status!==500)console.warn(`omie buscarNFs [${empresa}] HTTP ${resp.status}`);
      return[];
    }
    const data=await resp.json();
    if(data.faultstring||data.fault)return[];
    return data.nfCadastro??data.cadastros??[];
  }catch(e){
    console.warn(`omie buscarNFs [${empresa}] erro:`,e.message);
    return[];
  }
}

// Extrai itens de uma NF Omie no formato que o app consome
function extrairItensNF(nfOmie,empresa){
  const itens=nfOmie.det??(nfOmie.itens??[]);
  return(Array.isArray(itens)?itens:[itens]).map((d,i)=>({
    descricao:d.prod?.xProd??d.descricao??"Item "+(i+1),
    sku_forn:d.prod?.cProd??d.codigo??"",
    qty:parseFloat(d.prod?.qCom??d.quantidade??1),
    valor_unit:parseFloat(d.prod?.vUnCom??d.valor_unitario??0),
    numero_nf:nfOmie.ide?.nNF??nfOmie.nNF??nfOmie.numero_nf??"",
    empresa,
    raw:d,
  }));
}

async function incluirProdutoOmie(produto,cnpjEmpresa){
  if(import.meta.env.VITE_OMIE_SYNC_ENABLED!=="true")return{ok:false,err:"sync_desabilitado"};
  const creds=OMIE_CREDS[cnpjEmpresa];
  if(!creds?.app_key||creds.app_key.startsWith("undefined"))return{ok:false,err:"credenciais_nao_configuradas"};
  // Tenta encontrar produto existente pelo SKU do fornecedor antes de criar
  if(produto.sku_fornecedor){
    try{
      const rBusca=await fetch(OMIE_PROXY,{
        method:"POST",
        headers:{"Content-Type":"application/json","Authorization":`Bearer ${SUPABASE_ANON_KEY}`},
        body:JSON.stringify({
          endpoint:"geral/produtos",
          payload:{call:"ConsultarProduto",app_key:creds.app_key,app_secret:creds.app_secret,
            param:[{codigo_produto_integracao:produto.sku_fornecedor}]}
        })
      });
      const dBusca=await rBusca.json();
      if(dBusca.codigo_produto){
        return{ok:true,nCodProd:dBusca.codigo_produto,encontrado:true};
      }
    }catch(_){}
  }
  try{
    const resp=await fetch(OMIE_PROXY,{
      method:"POST",
      headers:{"Content-Type":"application/json","Authorization":`Bearer ${SUPABASE_ANON_KEY}`},
      body:JSON.stringify({
        endpoint:"geral/produtos",
        payload:{
          call:"IncluirProduto",
          app_key:creds.app_key,
          app_secret:creds.app_secret,
          param:[{
            codigo_produto_integracao:produto.sku,
            codigo:produto.sku,
            descricao:produto.name,
            unidade:produto.unidade||"UN",
            ncm:produto.ncm||"",
            valor_unitario:produto.price||0,
            tipo_item:"04",
          }]
        }
      })
    });
    if(!resp.ok)return{ok:false,err:"omie_http_"+resp.status};
    const data=await resp.json();
    if(data.faultstring)return{ok:false,err:data.faultstring};
    const nCodProd=data.codigo_produto;
    if(!nCodProd)return{ok:false,err:"sem_codigo_produto"};
    return{ok:true,nCodProd};
  }catch(e){return{ok:false,err:"rede_indisponivel"};}
}
async function incluirMovimentoOmie(produto,delta,cnpjEmpresa){
  if(import.meta.env.VITE_OMIE_SYNC_ENABLED!=="true")return{ok:false,err:"sync_desabilitado"};
  const creds=OMIE_CREDS[cnpjEmpresa];
  if(!creds?.app_key||creds.app_key.startsWith("undefined"))return{ok:false,err:"credenciais_nao_configuradas"};
  if(!produto.ncodprod_omie)return{ok:false,err:"sem_ncodprod"};
  try{
    const tipo=delta>0?"0":"1"; // 0=entrada, 1=saida
    const resp=await fetch(OMIE_PROXY,{
      method:"POST",
      headers:{"Content-Type":"application/json","Authorization":`Bearer ${SUPABASE_ANON_KEY}`},
      body:JSON.stringify({
        endpoint:"estoque/ajuste",
        payload:{
          call:"IncluirAjusteEstoque",
          app_key:creds.app_key,
          app_secret:creds.app_secret,
          param:[{
            id_prod:parseInt(produto.ncodprod_omie),
            data:new Date().toLocaleDateString('pt-BR'),
            quan:Math.abs(delta),
            valor:produto.price>0?produto.price:1.00,
            tipo:delta>0?'ENT':'SAI',
            obs:`Ajuste via EstoqueOS — delta ${delta>0?"+":""}${delta}`,
          }]
        }
      })
    });
    if(!resp.ok)return{ok:false,err:"omie_http_"+resp.status};
    const data=await resp.json();
    if(data.faultstring)return{ok:false,err:data.faultstring};
    return{ok:true};
  }catch(e){return{ok:false,err:"rede_indisponivel"};}
}

export {
  OMIE_CREDS,
  buscarNFsFaturadas,
  extrairItensNF,
  getLastCheck,
  setLastCheck,
  dentroDoHorarioComercial,
  POLL_INTERVAL_MS,
  incluirProdutoOmie,
  incluirMovimentoOmie,
};